'use strict';

// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

module.exports = require('./zh-CN');


//////////////////
// WEBPACK FOOTER
// ./~/grommet/messages/icons/zh.js
// module id = 200
// module chunks = 0